import { axios as _axios } from "@integration/axios/csr";

const axios = _axios.create({
  baseURL: "/api/track",
});

export { axios };
